<router-outlet>
  <div class="loading" *ngIf="!initialNavigationComplete">
    <div class="loading__inner"></div>
  </div>
</router-outlet>
